<template>
  <div class="nav-logo">
    <router-link :to="link"></router-link>
    <div class="logo-detail">
      <h2 v-if="title1">{{title1}}</h2>
      <h2 v-if="title2">{{title2}}</h2>
      <h2 v-if="title3">{{title3}}</h2>
      <h2 v-if="title4">{{title4}}</h2>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'title1',
    'title2',
    'title3',
    'title4',
    'link'
  ]
}
</script>

<style lang="sass" scoped>
@import "../../../assets/style/variable.sass"

$colorText: #464646

.nav-logo
  display: flex
  align-items: center
  line-height: 1
  a
    height: 66px
    width: 178px
    position: relative
    top: -3px
    background-image: url('../assets/logo-as-black.svg')
    background-position: center
    background-repeat: no-repeat
    background-size: contain
    +mobile
      height: 46px
      width: 124px
  .logo-detail
    border-left: 1px solid #888
    padding-left: 9px
    margin-left: 9px
    transition: all $speed ease-in-out
    h1
      margin-bottom: 6px
      font-size: 15px
      color: $colorText
    h2
      &:nth-child(n+2)
        margin-top: 3px
      font-size: 13px
      color: $colorText
    h3
      font-size: 12px
      color: $colorText
  +mobile
    .logo-detail
      display: none
  +tablet
    &.transparent
      a
        background-image: url('../assets/logo-as-white.svg')
      h1, h2, h3
        color: $white
        font-weight: 500
</style>
